import { AutoAwesomeMosaic, TableRows } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import React from "react";

const SelectView = ({handleView}) => {
  return (
    <Box pt={1} pb={1}>
      <Tooltip title="Mosaic View">
        <IconButton
          disableFocusRipple
          disableRipple
          onClick={() => handleView(1)}
        >
          <AutoAwesomeMosaic />
        </IconButton>
      </Tooltip>

      <Tooltip title="Table View">
        <IconButton
          disableFocusRipple
          disableRipple
          onClick={() => handleView(2)}
        >
          <TableRows />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default SelectView;
